import React from 'react';
import { EARMARK_TEXT_WIDTH_SCALE, EARMARK_WIDTH_PADDING, EARMARK_WIDTH_SCALE } from './constants';
import { EarmarkShapes } from './enums';
import { RectangleTagContainer, RectangleTagText, TagContainer, TagShape, TagShapeRect, TagText } from './style';
export const Earmark = ({ id, tagId, height, width, shape, active }) => {
    Earmark.defaultProps = {
        height: 20,
        width: 33,
        shape: EarmarkShapes.POLYGON,
        active: false
    };
    const formattedTagId = (tagId) => {
        if (tagId.length > 13)
            return tagId.substring(0, 10) + '...';
        return tagId;
    };
    const earMarkWidth = (tagId) => {
        return formattedTagId(tagId).length * EARMARK_WIDTH_SCALE + EARMARK_WIDTH_PADDING;
    };
    const earMarkTextWidth = (tagId) => {
        return formattedTagId(tagId).length * EARMARK_TEXT_WIDTH_SCALE;
    };
    return tagId ? (shape === EarmarkShapes.RECTANGLE ? (React.createElement(RectangleTagContainer, { id: `rect-tile-tag-${id}`, className: "mi-file-viewer-tag" },
        React.createElement("svg", { width: width, height: height, viewBox: "0 0 100 16" },
            React.createElement(TagShapeRect, { id: `rect-tile-tag-shape-${id}`, width: earMarkWidth(tagId), height: '100%', selected: active !== null && active !== void 0 ? active : false, className: `mi-file-viewer-tag-shape` }),
            React.createElement(RectangleTagText, { id: `rect-tile-tag-text-${id}`, x: "2", y: "10.5", textLength: earMarkTextWidth(tagId), selected: active !== null && active !== void 0 ? active : false, className: "mi-file-viewer-tag-text" }, formattedTagId(tagId))))) : (React.createElement(TagContainer, { id: `tile-tag-${id}`, className: "mi-file-viewer-tag" },
        React.createElement("svg", { width: width, height: height, viewBox: "0 0 33 20" },
            React.createElement(TagShape, { id: `tile-tag-shape-${id}`, points: "0,10, 7,0, 33,0, 33,20, 7,20", className: "mi-file-viewer-tag-shape" }),
            React.createElement(TagText, { id: `tile-tag-text-${id}`, x: "18", y: "15", className: "mi-file-viewer-tag-text" }, tagId))))) : (React.createElement(React.Fragment, null));
};
//# sourceMappingURL=Earmark.js.map